/** @jsx jsx */
import { jsx } from 'theme-ui';
export var Price = function (_a) {
    var className = _a.className, pennies = _a.pennies, decimal = _a.decimal, strike = _a.strike;
    var pounds = (Math.abs(pennies) / 100).toFixed(2);
    var str = pounds.endsWith('.00') && !decimal ? pounds.slice(0, -3) : pounds;
    var sign = pennies < 0 ? '-' : '';
    return (jsx("span", { className: className, sx: strike
            ? {
                display: 'inline-block',
                position: 'relative',
            }
            : undefined },
        sign,
        "\u00A3",
        str,
        strike && (jsx("div", { sx: {
                position: 'absolute',
                left: '-0.2em',
                right: '-0.2em',
                top: '50%',
                bottom: '0.38em',
                pointerEvents: 'none',
                height: '1px',
                transform: 'rotate(-7deg)',
                bg: 'currentColor',
            } }))));
};
//# sourceMappingURL=Price.js.map